import script from "./FeaturedFullSlider.vue?vue&type=script&setup=true&lang=js"
export * from "./FeaturedFullSlider.vue?vue&type=script&setup=true&lang=js"

import "./FeaturedFullSlider.vue?vue&type=style&index=0&id=310347da&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-310347da"]])

export default __exports__